export const secciones = {
  '1': 'NPS',
  '2': '陳述',
  '3': '控制問題',
  '4': '客層',
  '5': '公開問題',
  '6': '4所有實踐',
  '7': '其他問題',
  '8': 'NOM035聲明',
}
export const preguntas = {
  // '1': '單選項問題',
  '1': '多項選擇題（單選按鈕）',
  '2': '公開問題',
  '3': '聲明',
  '4': '多項選擇題（單選按鈕）',
  '5': '4全部練習',
  '6': '多項選擇題（“檢查”按鈕）',
  '7': 'NOM035聲明',
  '8': '音訊',
}
export const abiertas = {
  '1': '開啟文字',
  '2': '數字文字',
}
export const preguntasEspeciales = {
  '1': '普通問題',
  '2': '特殊問題',
}
